import { Injectable } from '@angular/core';

// campfire
import { PolicyService } from '@campfire-nx/api';

import { environment } from '@open-portal-env';

import { DOCUMENT_CONSTANTS } from '../constants/policy.constants';

@Injectable({
  providedIn: 'root'
})
export class PolicyDocumentService {
  constructor(
    private policyService: PolicyService
  ) { }

  static saveFileClientSide(data: any) {
    const header = data.headers.get('Content-Disposition');
    const fileName = header.split('=')[1] ? header.split('=')[1].replace(/"/g, '') : 'COI';
    const blob = new Blob([data.body], { type: 'application/pdf' });
    const link = document.createElement('a');

    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
  }

  downloadDocument(documentType: string, policy: any) {
    switch (documentType) {
      case 'coi':
        if (policy.isRaptorial) {
          this.policyService.downloadCoi(policy.slug)
          .subscribe((data) => {
            PolicyDocumentService.saveFileClientSide(data);
          });
        } else {
          // for legacy policies
          this.policyService.downloadLegacyCoi(policy.productClass, policy.slug)
            .subscribe((data) => {
              PolicyDocumentService.saveFileClientSide(data);
            });
        }
        break;
      case 'coc':
        if (policy.isRaptorial) {
          this.policyService.downloadCoc(policy.slug)
            .subscribe((data) => {
              PolicyDocumentService.saveFileClientSide(data);
            });
        } else {
          // for legacy policies
          this.policyService.downloadLegacyCoc(policy.productClass, policy.slug)
            .subscribe((data) => {
              PolicyDocumentService.saveFileClientSide(data);
            });
        }
        break;
      case 'pds':
      case 'supplementary':
        const document = Object.values(policy.documents).find((key: any) => key.type === documentType) as any;
        window.open(`${environment.apiEndpoint}${document.url}`, '_blank');
        break;
      default:
        break;
    }
  }

  updateDocumentList(documents: Array<{type: 'coi' | 'coc' | 'pds' | 'pd' | 'md', name: string, summary?: string, icon?: string, linkType?: string}>, countryCode: keyof typeof DOCUMENT_CONSTANTS) {
      const documentsList = documents;
      const constants = DOCUMENT_CONSTANTS[countryCode];

      if (!constants || Object.keys(constants).length === 0) {
        return [];
      }
      
      documentsList.forEach((document) =>  {
        const docType = document.type;
        if (docType in constants) {
          document.summary = constants[docType as keyof typeof constants].summary;
          document.icon = constants[docType as keyof typeof constants].icon;
          document.linkType = 'download';
        }
      });
      
      return documentsList;
    }
}
